import React from 'react';
import CancelIcon from "@material-ui/icons/Cancel";
import {ProgressPortraitListFilterValue} from "./domain";
import {ProgressPortraitListAction} from "./progressPortraitListReducer";
import {asQueryParam} from "./ProgressPortraitListFilter";
import {formatLocalDateString} from "../../../common/util/date";

type Props = {
    filter: ProgressPortraitListFilterValue;
    dispatch: React.Dispatch<ProgressPortraitListAction>;
    className?: string;
}

export function ProgressPortraitListFilterBadge({filter, dispatch, className}: Props) {
    let values: Array<string> = [];

    const params = asQueryParam(filter);
    if (params.reportDateFrom) {
        values = values.concat(`Report Date From: ${formatLocalDateString(params.reportDateFrom)}`);
    }
    if (params.reportDateTo) {
        values = values.concat(`Report Date To: ${formatLocalDateString(params.reportDateTo)}`);
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value.includes("Report Date From:")) {
            dispatch({type: 'SET_FILTER', filter: {...filter, reportDateFrom: null}});
            return;
        }
        if (value.includes("Report Date To:")) {
            dispatch({type: 'SET_FILTER', filter: {...filter, reportDateTo: null}});
            return;
        }
    };

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className={`flex items-start min-w-0 ${className ?? 'pl-5'}`}>
            <div className='pt-2 pr-5 flex-grow-0 shrink-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
